// extracted by mini-css-extract-plugin
export default {"container":"QueryPrompt_container__2Kzc0","input":"QueryPrompt_input__1IB1T","apiButton":"QueryPrompt_apiButton__1wmLw","handle":"QueryPrompt_handle__1las1"};